import { AccountCircle } from "@mui/icons-material";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { soulApi } from "../data/api/SoulApi";
import { useAuth } from "../data/providers/AuthProvider";

const GREEN = "#00C853";

async function getCustomToken({ referencedUser }: { referencedUser: string }): Promise<string> {
  const result = await soulApi.getCustomTokenAsAdmin.request({ referencedUser });
  if (!result?.isSuccess) throw new Error("Error on getCustomToken");
  return result.data?.token!;
}

export const ImpersonateIcon = ({ referencedUser }: { referencedUser: string }) => {
  const { loginAsOther } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleImpersonate = async () => {
    try {
      setLoading(true);
      const token = await getCustomToken({ referencedUser });
      await loginAsOther(token);
      window.location.href = "/dashboard";
    } catch (err) {
      console.error("Error impersonating user", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Entrar como este usuario">
      <span>
        <IconButton onClick={handleImpersonate} disabled={loading} size="small"
          sx={{ bgcolor: `${GREEN}18`, color: GREEN, border: `1px solid ${GREEN}44`, borderRadius: 2, width: 32, height: 32, "&:hover": { bgcolor: `${GREEN}33` } }}>
          {loading ? <CircularProgress size={16} sx={{ color: GREEN }} /> : <AccountCircle sx={{ fontSize: 18 }} />}
        </IconButton>
      </span>
    </Tooltip>
  );
};
